import { render } from "./ShortlinkRow.vue?vue&type=template&id=5315dd50"
import script from "./ShortlinkRow.vue?vue&type=script&lang=js"
export * from "./ShortlinkRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__